var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-detail" }, [
    _c("div", { staticClass: "detail-section" }, [
      _c("h3", [_vm._v("基本信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-grid" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("销售单号：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.productionOrder))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("产品名称：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.auditName))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("订单金额：")]),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { "font-weight": "600", color: "#303133" } },
            [_vm._v("¥" + _vm._s((_vm.order.amount || 0).toFixed(2)))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("创建时间：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.createTime))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("状态：")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "order-status",
              class: {
                "o-status-pending": _vm.order.productionStatus === "未提交",
                "o-status-submitted": _vm.order.productionStatus === "已提交",
                "o-status-unknown": !["未提交", "已提交"].includes(
                  _vm.order.productionStatus
                ),
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.order.productionStatus) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail-section" }, [
      _c("h3", [_vm._v("附件信息")]),
      _vm._v(" "),
      _vm.attachments.length > 0
        ? _c(
            "div",
            { staticClass: "attachment-list" },
            _vm._l(_vm.attachments, function (att, index) {
              return _c("div", { key: index, staticClass: "attachment-item" }, [
                _c("span", { staticClass: "attachment-name" }, [
                  _vm._v(_vm._s(att.fileName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "attachment-product" }, [
                  _vm._v(_vm._s(att.productName)),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "attachment-link",
                    attrs: { href: att.url, target: "_blank" },
                  },
                  [_vm._v("打开")]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail-section" }, [
      _c("h3", [_vm._v("物流信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-grid" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("送货方式：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.deliveryMethod || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("齐套状态：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.setStatus || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("入库日期：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.storageDate || "-"))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail-section" }, [
      _c("h3", [_vm._v("产品信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-grid" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("包数：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.packageCount || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("产品体积：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.productVolume || "-") + " m³")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("产品重量：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.productWeight || "-") + " kg")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("展开面积：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.expandedArea || "-") + " m²")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("玻璃门：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.glassDoor || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("模压门：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.moldingDoor || "-"))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail-section" }, [
      _c("h3", [_vm._v("石材信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-grid" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("石材材质：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.stoneMaterial || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("石材颜色：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.stoneColor || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("石材生产：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.stoneProduction || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("石材延长：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.stoneExtension || "-") + " m")]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail-section" }, [
      _c("h3", [_vm._v("配件信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-grid" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("水盆来源：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.waterBasinSource || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("水盆数量：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.waterBasinCount || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("水盆型号：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.waterBasinModel || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("龙头来源：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.faucetSource || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("龙头数量：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.faucetCount || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("龙头型号：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.order.faucetModel || "-"))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }